import React from "react";
import HomeFooter from "./components/Footer";
import Menu from './Menu';

import './ProjetTest.css';

const LesObjetifs = () =>{

    return(
        <>
        <Menu></Menu>

<div className="envelope-projeto">
        <div className="banner-projeto">
            <div className="poster_onglet">
              
                </div>
                <div className="poster_onglet_700">
              
              </div>
        </div>
     <div className="container-objectifs">    
    <div className="les-objetifs" id="">
    
        <div className="les-objetifs-text">
            <div className="les-objetifs-text inicio">
                <p className="p-objectifs">Les objectifs</p>
            </div>
            <div className="text-principal">

            <div className="text-objetifs">
             <p className="text-objetifs-body-text">
              <div className="en-bonne-entente">
                <p className="en-bonne-entente-text">  <b>EN BONNE ENTENTE… </b></p>
              </div>
   
             - promeut l'engagement associatif de tous et toutes en contexte multiculturel et multilingue ; <br></br>

            - donne une visibilité aux événements associatifs et à l'offre associative du et dans le quartier de Bonnevoie ; <br></br>

            - valorise les pratiques associatives du point de vue du bénévolat, de la gouvernance, du multilinguisme, de la diversité, de l’entraide ; <br></br>

            - propose un quiz destiné à découvrir le dynamisme associatif dans le quartier de Bonnevoie.<br></br></p>   
        
           </div>
           </div>
        </div>
</div>
</div>  

</div>

        </>
    );
}

export default LesObjetifs;